import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useEffect } from "react";

// Icons
import bkashLogo from "../assets/bkash.png";
import nogodLogo from "../assets/nogod.png";
import rocketLogo from "../assets/rocket.png";

const paymentMethods = [
  { name: "বিকাশ", img: bkashLogo },
  { name: "নগদ", img: nogodLogo },
  { name: "রকেট", img: rocketLogo },
];

const presetAmounts = [300, 500, 1000, 5000, 10000];

const WithdrawPage = () => {
  const navigate = useNavigate();

  const [mainBalance, setMainBalance] = useState(null); // ইউজারের Main Balance

// ==================== fetchMainBalance function ====================
const fetchMainBalance = async () => {
  try {
    const res = await axios.get(
      "https://api.earnmoney0.top/api/user/main-balance",
      { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
    );
    if (res.data.success) {
      setMainBalance(res.data.balance);
    }
  } catch (err) {
    console.error("❌ Failed to fetch main balance:", err);
  }
};

// ==================== useEffect call ====================
useEffect(() => {
  fetchMainBalance(); // এখন defined
  fetchHistory();     // withdraw history fetch
}, []);

  const [selectedMethod, setSelectedMethod] = useState(null);
  const [amount, setAmount] = useState("");
  const [account, setAccount] = useState("");
  const [error, setError] = useState("");
  const [isExceedBalance, setIsExceedBalance] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false); // ✅ Withdraw submission ট্র্যাক করবে

  // নতুন কোড
const [withdrawHistory, setWithdrawHistory] = useState([]); // API থেকে আসবে

// ==================== fetchHistory function ====================
const fetchHistory = async () => {
  try {
    const token = localStorage.getItem("token");
    const res = await axios.get(
      "https://api.earnmoney0.top/api/withdraw/history",
      { headers: { Authorization: `Bearer ${token}` } }
    );
    if (res.data.success) {
      setWithdrawHistory(res.data.withdraws);
    }
  } catch (err) {
    console.error("❌ Failed to fetch withdraw history:", err);
  }
};

// ==================== useEffect ====================
useEffect(() => {
  fetchMainBalance(); // balance fetch
  fetchHistory();     // withdraw history fetch
}, []);

 const handleWithdraw = async () => {
  if (isSubmitting) return; // ✅ prevent multiple clicks

  if (!selectedMethod) {
    alert("পেমেন্ট মেথড সিলেক্ট করুন");
    return;
  }

  if (!amount || amount < 300) {
  alert("কমপক্ষে ৩০০ টাকা উইথড্র করতে হবে ৳");
  return;
}

  if (!account) {
    alert("আপনার নাম্বার দিন");
    return;
  }

  setIsSubmitting(true); // start submission
  setError(""); // clear previous error

  try {
    const token = localStorage.getItem("token");

    const res = await axios.post(
      "https://api.earnmoney0.top/api/withdraw/request",
      {
        amount,
        account,
        method: selectedMethod,
      },
      { headers: { Authorization: `Bearer ${token}` } }
    );

    if (res.data.success) {
      alert("🎉 Withdraw Request গ্রহণ করা হয়েছে");
      await fetchHistory(); // history refresh

      setAmount("");
      setAccount("");
      setSelectedMethod(null);
    } else {
      setError(res.data.message || "❌ Withdraw Request ব্যর্থ হয়েছে");
    }
  } catch (err) {
    console.error(err);
    setError("❌ Withdraw Request পাঠানো যায়নি");
  } finally {
    setIsSubmitting(false); // end submission
  }
};

  return (
    <div style={styles.page}>
      {/* Header */}
      <div style={styles.header}>
        <button onClick={() => navigate(-1)} style={styles.backBtn}>
          ←
        </button>
        <h2 style={styles.headerTitle}>Withdraw</h2>
      </div>

      {/* Method */}
      <div style={styles.card}>
        <h3 style={styles.cardTitle}>পেমেন্ট মেথড</h3>
        <div style={styles.paymentGrid}>
          {paymentMethods.map((m) => (
            <div
              key={m.name}
              onClick={() => setSelectedMethod(m.name)}
              style={{
                ...styles.paymentBox,
                borderColor:
                  selectedMethod === m.name ? "#16a34a" : "#ddd",
              }}
            >
              <img src={m.img} alt={m.name} style={styles.paymentIcon} />
              <p>{m.name}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Amount */}
      <div style={styles.card}>
        <h3 style={styles.cardTitle}>Amount</h3>

        <p style={{ marginBottom: 8, fontWeight: 700, fontSize: 16 }}>
  Balance:{" "}
  <span style={{ color: "#16a34a" }}>৳{mainBalance}</span>
</p>

        <input
  type="number"
  placeholder="টাকার পরিমাণ"
  value={amount}
  onChange={(e) => {
  const val = Number(e.target.value); // number এ convert করা হলো
  setAmount(val);

  if (val > mainBalance) {
    setIsExceedBalance(true);
  } else {
    setIsExceedBalance(false);
  }
}}
  style={styles.input}
/>

        <div style={styles.presetWrapper}>
          {presetAmounts.map((a) => (
            <button
  key={a}
  onClick={() => {
    setAmount(a);
    setIsExceedBalance(a > mainBalance); // check add করা হলো
  }}
  style={styles.presetBtn}
>
  {a}
</button>
          ))}
        </div>
      </div>

      {/* Account */}
      <div style={styles.card}>
        <h3 style={styles.cardTitle}>আপনার নাম্বার</h3>
        <input
          type="text"
          placeholder="Bkash / Nagad / Rocket নাম্বার"
          value={account}
          onChange={(e) => setAccount(e.target.value)}
          style={styles.input}
        />
      </div>

      {/* Button */}
      {isExceedBalance ? (
  <p style={{ color: "#ef4444", fontWeight: 600, marginTop: 10 }}>
    ⚠️ আপনার ব্যালেন্স সর্বোচ্চ অতিক্রম করেছে
  </p>
) : (
  <button
  onClick={handleWithdraw}
  disabled={isSubmitting || isExceedBalance} // disabled যখন submission চলবে বা balance exceed
  style={{
    ...styles.withdrawBtn,
    background: isSubmitting ? "#9d4edd" : "#7a0f7a",
    cursor: isSubmitting ? "not-allowed" : "pointer",
  }}
>
  {isSubmitting ? "Processing..." : "টাকা উত্তোলন করুন 💸"}
</button>
)}

      {/* History */}
      <div style={styles.card}>
        <h3 style={styles.cardTitle}>Withdraw History</h3>

        {withdrawHistory.length === 0 ? (
          <p>No withdraw history</p>
        ) : (
          <table style={{ width: "100%" }}>
            <thead>
              <tr>
                <th>Date</th>
                <th>Method</th>
                <th>Amount</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {withdrawHistory.map((w, i) => (
                <tr key={i}>
                  <td>{w.date}</td>
                  <td>{w.method}</td>
                  <td>৳{w.amount}</td>
                  <td>{w.status}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default WithdrawPage;

/* ================= STYLES ================= */
const styles = {
  page: { minHeight: "100vh", background: "#f5f5f5", padding: 15 },
  header: {
    background: "#7a0f7a",
    color: "#fff",
    padding: 12,
    display: "flex",
    gap: 10,
    borderRadius: 8,
  },
  backBtn: { background: "none", border: "none", color: "#fff", fontSize: 20 },
  headerTitle: { margin: 0 },
  card: {
    background: "#fff",
    padding: 15,
    borderRadius: 12,
    marginTop: 15,
  },
  cardTitle: { marginBottom: 10, color: "#7a0f7a" },
  paymentGrid: { display: "flex", gap: 10 },
  paymentBox: {
    flex: 1,
    border: "2px solid #ddd",
    padding: 10,
    textAlign: "center",
    borderRadius: 8,
    cursor: "pointer",
  },
  paymentIcon: { width: 45, height: 45 },
  input: {
    width: "100%",
    padding: 10,
    borderRadius: 8,
    border: "1px solid #ccc",
  },
  presetWrapper: { display: "flex", gap: 10, marginTop: 10 },
  presetBtn: {
    padding: "6px 12px",
    borderRadius: 20,
    border: "1px solid #2563eb",
    background: "#fff",
    color: "#2563eb",
  },
  withdrawBtn: {
    width: "100%",
    marginTop: 15,
    padding: 12,
    background: "#7a0f7a",
    color: "#fff",
    border: "none",
    borderRadius: 12,
    fontSize: 16,
    fontWeight: 600,
  },
};